// Builds and manages the dynamic point rows in the sidebar.

let nextId = 1;

export function createPointsController({ listEl, kind, onChange }) {
  const points = [];

  function add(initial = {}) {
    const id = nextId++;
    const row = renderPoint({ id, kind, onRemove: () => remove(id), onChange });
    listEl.appendChild(row.el);
    points.push({ id, kind, row, lat: null, lon: null, label: '', ...initial });
    onChange?.();
    return points[points.length - 1];
  }

  function remove(id) {
    const i = points.findIndex((p) => p.id === id);
    if (i < 0) return;
    points[i].row.el.remove();
    points.splice(i, 1);
    onChange?.();
  }

  function getAll() {
    return points.map((p) => ({
      id: p.id,
      kind,
      address: p.row.getAddress(),
      mode: p.row.getMode(),         // 'time' | 'radius'
      profile: p.row.getProfile(),   // 'driving-car' | 'cycling-regular' | 'foot-walking'
      value: p.row.getValue(),       // minutes or km
      lat: p.lat,
      lon: p.lon,
      label: p.label,
      setResolved: (r) => {
        p.lat = r.lat; p.lon = r.lon; p.label = r.label;
        p.row.setResolved(r.label);
      },
      setError: (msg) => p.row.setError(msg),
      setBusy: (b) => p.row.setBusy(b)
    }));
  }

  return { add, remove, getAll };
}

function renderPoint({ id, kind, onRemove, onChange }) {
  const el = document.createElement('div');
  el.className = 'point';
  el.dataset.kind = kind;
  el.innerHTML = `
    <button type="button" class="remove" title="Remove" aria-label="Remove">${svg('close')}</button>
    <label class="field">
      <span class="label">Address</span>
      <input type="text" class="addr" placeholder="e.g. Berlin, or Münchner Str. 12" autocomplete="off" />
    </label>
    <div class="row-grid">
      <label class="field">
        <span class="label">Mode</span>
        <select class="mode">
          <option value="time">Travel time</option>
          <option value="radius">Radius</option>
        </select>
      </label>
      <label class="field profile-field">
        <span class="label">Profile</span>
        <select class="profile">
          <option value="driving-car">Drive</option>
          <option value="cycling-regular">Bike</option>
          <option value="foot-walking">Walk</option>
        </select>
      </label>
      <label class="field">
        <span class="label"><span class="value-label">Minutes</span></span>
        <div class="value-wrap">
          <input type="number" class="value" value="30" min="1" max="120" step="1" />
          <span class="unit">min</span>
        </div>
      </label>
    </div>
    <div class="resolved"></div>
  `;

  const $ = (s) => el.querySelector(s);

  $('.remove').addEventListener('click', onRemove);
  $('.addr').addEventListener('change', () => onChange?.());
  const modeSel = $('.mode');
  modeSel.addEventListener('change', () => {
    const isTime = modeSel.value === 'time';
    el.querySelector('.profile-field').style.display = isTime ? '' : 'none';
    el.querySelector('.unit').textContent = isTime ? 'min' : 'km';
    el.querySelector('.value-label').textContent = isTime ? 'Minutes' : 'Kilometers';
    const v = el.querySelector('.value');
    v.max = isTime ? 120 : 500;
    onChange?.();
  });

  return {
    el,
    getAddress: () => $('.addr').value.trim(),
    getMode: () => $('.mode').value,
    getProfile: () => $('.profile').value,
    getValue: () => Number($('.value').value) || 0,
    setResolved: (label) => {
      const r = $('.resolved');
      r.textContent = label ? `✓ ${label}` : '';
      r.classList.toggle('ok', !!label);
      r.classList.remove('err');
    },
    setError: (msg) => {
      const r = $('.resolved');
      r.textContent = `✗ ${msg}`;
      r.classList.remove('ok');
      r.classList.add('err');
    },
    setBusy: (b) => {
      el.classList.toggle('busy', !!b);
    }
  };
}

function svg(name) {
  if (name === 'close') {
    return `<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>`;
  }
  return '';
}
